export default class InPageSkinGroup {
  id = null
  name = ''
  inPageSkins = []
  isTma = false

  constructor(data) {
    if (!data) return

    this.id = data.id ?? null
    this.name = data.name ?? ''
    this.isTma = data.is_tma ?? false
    this.inPageSkins = data.in_page_skins?.map((skin) => ({
      id: skin.id ?? null,
      name: skin.name ?? '',
      tdsId: skin.tds_id ?? null
    })) ?? []
  }
}
